export const environment = {
    production: true,
    appUrl: 'https://www.shriramwealth.in/',
    env: 'prod',
    appName: 'shriram-wealth',
    apiUrl: "https://api.shriramwealth.in/api/v1/",
    appDomain: '',
    appDomainUrl: '',
    serverUrl: 'http://127.0.0.1:4000/',
    previewServerUrl: '',
    instance: 'v1',
    assetsCDNUrl: '',
    webSiteUrl: '',
    mapApiKey: ''
};
